// @vendors
import React, { memo, useMemo } from 'react';

// @assets
import { StatsStyles } from '../../../assets/css/statsBoxes-style.js';

// @components material
import {
  AssignmentTurnedInOutlinedIcon,
  Grid,
  PersonAddAlt1OutlinedIcon,
  PersonRemoveOutlinedIcon,
} from '../../../components/shared/MaterialUI.js';

// @components
import EmployerProfilePic from './EmployerProfilePic';

// @services
import StatsBoxCard from '../../../components/atoms/StatsBoxCard.jsx';

const EmployerStats = memo(({ id, stats }) => {
  //const styles = useMemo(() => EmployerStyles(),[]);
  const stylesStas = useMemo(() => StatsStyles(),[]);
 /*  let boxes = [
    {
      title: 'Number of employees',
      type: 'employees',
      icon: <PersonAddAlt1OutlinedIcon sx={styles.statsIcon} />,
    },
    {
      title: 'Completed questionnaires',
      type: 'questionnaireCompleted',
      icon: <AssignmentTurnedInOutlinedIcon sx={styles.statsIcon} />,
    },
    {
      title: 'Abandoned questionnaires',
      type: 'questionnaireAbandoned',
      icon: <PersonRemoveOutlinedIcon sx={styles.statsIcon} />,
    },
  ]; */

  return (
    <Grid
      component={'section'}
      sx={{
        ...stylesStas.container,
        margin: '0px 0 20px 0'
      }}
    >
      <EmployerProfilePic id={id}/>

      <StatsBoxCard
        title='Number of employees'
        iconStats={<PersonAddAlt1OutlinedIcon sx={stylesStas.statsIcon}/>}
        value={stats?.employees}
        hasButton={false}
      />

      <StatsBoxCard
        title='Completed questionnaires'
        iconStats={<AssignmentTurnedInOutlinedIcon sx={stylesStas.statsIcon}/>}
        value={stats?.questionnaireCompleted}
        hasButton={false}
      />

      <StatsBoxCard
        title='Abandoned questionnaires'
        iconStats={<PersonRemoveOutlinedIcon sx={stylesStas.statsIcon}/>}
        value={stats?.questionnaireAbandoned}
        hasButton={false}
      />

      {/* {React.Children.toArray(
      boxes.map((box) => {
        return (
            <Card elevation={3} sx={styles.statsBox}>
              {box.icon}
              <CardContent>
                <Typography>{box.title}</Typography>
                {
                  Object.entries(stats).length === 0
                    ? <Typography>
                        <CircularProgress color="inherit" size="20px"/>
                      </Typography>
                    : <Typography>{stats[box.type] || 0}</Typography>
                }
                
              </CardContent>
            </Card>
        );
      })
    )} */}
    </Grid>
  );
});

export default EmployerStats;
